import { render, staticRenderFns } from "./DeviceDetailDialog.vue?vue&type=template&id=b84948fc&scoped=true&"
import script from "./DeviceDetailDialog.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84948fc",
  null
  
)

export default component.exports